export interface VerifyConfigModel {
    custNo: string;
    shopId?: number;
    shopId4?: number;
    infoId?: number;
    infoId4?: number;
    shopNm?: string;
    shopNm4?: string;
    memberId?: number;
    couponIds?: string;
    ttaNum?:number;
}
export interface TtaSecModel{
    id: number;
    idx: number;
    shopId?: number;
    couponId?: number;
    infoId?: number;
    shopNm?: string;
    couponNm?: string;
    savePoint?: number;
    shopCnt? : number;
    startTime?: string;
    endTime?: string;
    difSec?: string;
    recency?: number;
    frequency?: number;
    arpu?: number;
    rscore?:number;
    fscore?:number;
    mscore?: number;
    rfmScore?: number;
    result?: boolean;
    resultMsg?: string;
    memo?:string;
    cpSrtDate?: string;
    cpEndDate?: string;
    rn?: number;
    fn?: number;
    ap?: number;
    myCouponCnt?: number;
    couponUsed?: number;
    availCnt?: number;

    prevData?: TtaPrevModel;
    encCode?: string;
}
export interface TtaPrevModel{
    savePoint?: number;
    shopCnt?: number;
    couponCnt?: number;
    loginDttm?: string;
    ssoKey?: string;
    memo?: string;
    result?: boolean;
    resultMsg?: string;
}

export const getSessionCustNo = () => {
    let rval: string = '';
    const model = getSessionVerify();
    if (model.custNo !== '') {
        rval = model.custNo;
    }
    return rval;
}
export const getSessionVerify = () => {
    const model = localStorage.getItem('verifyConfig');
    let entity: VerifyConfigModel = {custNo: ''};
    if (model) {
        entity = JSON.parse(model);
    }
    return entity;
}
